// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"localAgents_FormTitle__Mr4YG"};